import React, { type FunctionComponent, useMemo } from 'react';

import { useAppSelector } from 'redux-store/hooks';
import { selectAppSettings, selectTranslations } from 'redux-store/rootReducer';
import type { IAppSettings } from 'redux-store/settings/settings.store';
import type ISkyttaTranslations from 'redux-store/translations/ISkyttaTranslations';

interface IContextProps {
  settings: IAppSettings;
  translations: ISkyttaTranslations;
  useMetric: boolean;
}

const KompisContext = React.createContext({} as IContextProps);

export const useKompis = () => {
  return React.useContext(KompisContext);
};

export const KompisProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
  const settings = useAppSelector(selectAppSettings);
  const translations = useAppSelector(selectTranslations);

  const memoValues = useMemo(() => {
    if (!settings || !translations) {
      return null;
    }

    const useMetric = settings.localisation.useMetricMeasures;

    return {
      settings,
      translations,
      useMetric
    };
  }, [settings, translations]);

  if (!memoValues) {
    return null;
  }

  return <KompisContext.Provider value={memoValues}>{children}</KompisContext.Provider>;
};
